import { Countdown, CountdownProps } from './Countdown'
import { AnalogCountdownRenderer } from './AnalogCountdownRenderer'

export default (props: Omit<CountdownProps, 'component'>) => (
  // TODO fix any typings here
  // eslint-disable-next-line
  <Countdown {...props} component={AnalogCountdownRenderer as any} />
)
